import { render, staticRenderFns } from "./huanjing.vue?vue&type=template&id=6ece9385&scoped=true&"
import script from "./huanjing.vue?vue&type=script&lang=js&"
export * from "./huanjing.vue?vue&type=script&lang=js&"
import style0 from "./huanjing.vue?vue&type=style&index=0&id=6ece9385&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ece9385",
  null
  
)

export default component.exports